'use strict';

export class HighlightsAndTestimonials {
  constructor() {
    // $(".paragraph--type--testimonial .block-testimonials>.field--name-field-items,.paragraph--type--highlight .block-highlight>.field--name-field-items").each(function () {
    //     var next = $(this).next();
    //    $(this).append(next.clone().addClass("field__item"))
    //    next.detach();
    // })
  }
}
